import React from 'react'
import PropTypes from 'prop-types';
import ModalContainer from '../Modal/Modal.container';
import { FormattedMessage } from 'react-intl';
import StyledForm from '../Form/Form.styled';
import StyledButton from '../Form/Button/Button.styled';
import StyledLabel from '../Form/Label/Label.styled';

const LocationExpiryModal = ({ 
  expiredLocation, 
  onClose, 
  updateLocation, 
  confirmLocation, 
  isLoading, 
}) => {
  const formData = [
    ['locations.form.name', expiredLocation.name],
    ['locations.form.email', expiredLocation.email],
    ['locations.form.phone', expiredLocation.phone],
  ]

  return (
    <ModalContainer onClose={onClose}>

      <FormattedMessage tagName="h2" id="locations.locationExpiry.title" />
      <StyledLabel>
        <FormattedMessage tagName="h4" id="locations.locationExpiry.description" />
      </StyledLabel>

      <StyledForm>
        {formData.map(([path, value]) => (
          <React.Fragment key={path}>
            <StyledLabel>
              <FormattedMessage id={path} />
            </StyledLabel>
            <div className='placeholder'>{value || '-'}</div>
          </React.Fragment>
        ))}

        <div className="buttons">
          <StyledButton 
            type="button" 
            $secondary 
            onClick={() => updateLocation()}
            disabled={isLoading}
          >
            <FormattedMessage id="forms.edit" />
          </StyledButton>

          <StyledButton 
            type="button" 
            onClick={() => confirmLocation()} 
            disabled={isLoading}
          >
            <FormattedMessage id="forms.confirm" />
          </StyledButton>
        </div>
      </StyledForm>
    </ModalContainer>
  )
}

LocationExpiryModal.propTypes = {
  expiredLocation: PropTypes.object,
  onClose: PropTypes.func,
  updateLocation: PropTypes.func,
  confirmLocation: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default LocationExpiryModal
